import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null; // No loading indicator
  }

  // If not authenticated, redirect to login page without preserving current path
  return currentUser ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;